<template>
  <div v-if="isMobile">
  <div class="sa-transparent" :class="{ isOpen: isOpen }" @click="close"></div>
  <div class="sa-mob-nav" :class="{ isOpen: isOpen }">
    <div class="sa-mob-nav-opener" @click="toggle"><i class="icon-menu-bar"></i></div>
    <!-- <i class="icon-logo logo"></i> -->
        <img class="logo" src="https://static.sanar.sa/images/static/logo.svg" alt="logo" />
    <el-scrollbar wrapClass="scrollbar-wrapper">
    <el-menu :default-active="activeMenu" :router="true" class="el-menu-vertical-demo" unique-opened>
      <template v-for="(item, menu) in menuItem">
        <el-submenu v-if="item && item.sub" :index="item.path" :fid="item.fid" v-bind:key="menu" :class="`item-${menu}`">
            <template slot="title">
              <i @click="scrollToElement(`item-${menu}`, {behavior: 'smooth'})" v-bind:class="item.icon"></i>
              <span @click="scrollToElement(`item-${menu}`, {behavior: 'smooth'})">{{item.info}}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item v-for="(item, submenu) in item.sub" :index="item.path" :key="submenu" :eid="item.eid">
                <span slot="title" @click="close">{{ item.name }}</span></el-menu-item>
            </el-menu-item-group>
        </el-submenu>
        <el-menu-item :index="item.path" v-bind:key="menu" :fid="item.fid" :class="`item-${menu}`" v-else>
          <i v-bind:class="item.icon" @click="close"></i>
          <span slot="title" @click="close">{{item.info}}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </el-scrollbar>
  <div v-if="loading" class="loading"></div>
  </div>
  </div>
<nav :class="{active: expCollapseFlag}" v-else>
  <el-radio-group v-model="isCollapse">
        <el-radio-button :label="false">
          <!-- <i class="icon-logo-symbol logo" @click="expCollapse"></i> -->
          <img class="logo" src="https://static.sanar.sa/images/static/logo.svg" alt="logo" @click="expCollapse" />
        </el-radio-button>
        <el-radio-button :label="true">
          <!-- <i class="icon-logo logo" @click="expCollapse"></i> -->
          <img class="logo" src="https://img.litedev.com/images/static/logo.svg" alt="logo" @click="expCollapse" />
        </el-radio-button>
      </el-radio-group>
  <el-scrollbar wrapClass="scrollbar-wrapper">
    <el-menu :default-active="activeMenu" :router="true" class="el-menu-vertical-demo" :collapse="isCollapse" unique-opened>
      <template v-for="(item, menu) in menuItem">
        <el-submenu v-if="item && item.sub && _.includes(functionid, item.fid)" :index="item.path" :fid="item.fid" v-bind:key="menu" :class="`item-${menu}`">
            <template slot="title">
              <i @click="scrollToElement(`item-${menu}`, {behavior: 'smooth'})" v-bind:class="item.icon"></i>
              <span @click="scrollToElement(`item-${menu}`, {behavior: 'smooth'})">{{item.info}}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item v-for="(item, submenu) in item.sub" :index="item.path" :key="submenu" :eid="item.eid">
                <span slot="title">{{ item.name }}</span></el-menu-item>
            </el-menu-item-group>
        </el-submenu>
        <el-menu-item :index="item.path" v-bind:key="menu" :fid="item.fid" :class="`item-${menu}`" v-if="item && !item.sub &&  _.includes(functionid, item.fid)">
          <i v-bind:class="item.icon"></i>
          <span slot="title">{{item.info}}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </el-scrollbar>
  <div v-if="loading" class="loading"></div>
</nav>
</template>
<script>
import API from "../../services/api.js";
var myBody = document.getElementsByTagName('body')[0];
export default {
  data () {
    return {
        activeMenu: '/dashboard',
        loading: false,
        isCollapse: false,
        menuItem: [],
        expCollapseFlag: true,
        isMobile: false,
        isOpen: false,
    }
  },
  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: false })
    }
  },
  methods: {
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
      myBody.classList.remove('is-active');
    },
    toggle() {
      if (this.isOpen) {
        this.close();
        myBody.classList.remove('is-active');
      } else {
        this.open();
        myBody.classList.add('is-active');
      }
    },
    onResize () {
      this.isMobile = window.innerWidth < 768
    },
    scrollToElement: function(element, options) {
      let _self = this
      setTimeout (() =>{
        const el = _self.$el.getElementsByClassName(element);
        if (el && el[0]) {
           el[0].scrollIntoView(options);
        }
      },300);
    },
    expCollapse: function() {
      this.expCollapseFlag = !this.expCollapseFlag
    },
    menuItemList(){
      let _self = this
      let params= {client: "Bupa"}
      _self.loading =  true;
      API.getMenuData(params, function(response) {
        if (response.status === 1000) {
          _self.menuItem = response.data.menuItem;
        }
        _self.loading =  false;
      });
    }
  },
  mounted() {
    this.activeMenu = this.$route.fullPath
    this.menuItemList();
    this.scrollToElement();
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: false })
    var myBody = document.getElementsByTagName('body')[0];
  },
  computed: {
    functionid() {
      let self = this;
      self.funsData = Object.keys(JSON.parse(localStorage.getItem("fnids")))
      return self.funsData;
    },
    eventid() {
      let self = this;
      self.eventsData = Object.keys(JSON.parse(localStorage.getItem("eventids")));
      return self.eventsData;
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/common/Navigation.vue